/* =====================================================================
   FIVE OCEANS — Product photo gallery  (assets/fo-product-gallery.js)
   - Phone/tablet: swipe photos + dots, video slide that plays muted
     with a sound button.
   - Desktop: zoom viewer (big photo + thumbnails on the side, click /
     mouse wheel / + − zoom).
   - Phone: full-screen viewer, photos one under the other, X on top,
     two-finger zoom.
   Used by sections/fo-product-page.liquid
   ===================================================================== */
(function () {
  if (window.FOGallery) return;

  var NAVY = '#1b365d';
  var GOLD = '#f2cb05';
  var Z = 2147483647;

  /* ---------- styles for the viewers (added once) ---------- */
  var CSS = [
    '.fo-gv{position:fixed;inset:0;z-index:' + Z + ';font-family:var(--font-body-family,"Lato",Arial,sans-serif);color:' + NAVY + ';-webkit-font-smoothing:antialiased}',
    '.fo-gv *{box-sizing:border-box}',
    '.fo-gv button{font-family:inherit;margin:0;-webkit-tap-highlight-color:transparent}',
    '.fo-gv img{max-width:none!important;max-height:none!important}',
    '.fo-gv-label{font-family:var(--font-heading-family,"Lato",Arial,sans-serif);font-size:13px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;color:' + NAVY + '}',
    '.fo-gv-x{width:46px;height:46px;border-radius:50%;border:0;padding:0;background:' + NAVY + ';display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0}',
    '.fo-gv-x:hover{background:#0f2444}',
    '.fo-gv-x svg{width:20px;height:20px;stroke:#fff;stroke-width:2.4;stroke-linecap:round;fill:none}',

    /* desktop */
    '.fo-gv-back{background:rgba(15,36,68,.55);display:flex;align-items:center;justify-content:center;padding:32px}',
    '.fo-gv .fo-gv-d{display:flex!important;flex-direction:row!important;align-items:stretch!important;gap:24px;padding:24px;width:min(1360px,100%);height:min(860px,100%);background:#f0f0f0;border-radius:20px;box-shadow:0 24px 70px rgba(15,36,68,.35);overflow:hidden}',
    '.fo-gv-stage{flex:1;position:relative;min-width:0;background:#fff;border:1px solid #e3e7ed;border-radius:18px;overflow:hidden}',
    '.fo-gv-area{position:absolute;inset:40px;display:flex;align-items:center;justify-content:center;user-select:none;-webkit-user-select:none}',
    '.fo-gv-stage{cursor:zoom-in}',
    '.fo-gv-stage.is-zoomed{cursor:zoom-out}',
    '.fo-gv-frame{height:100%;max-width:100%;border-radius:18px;overflow:hidden;background:#fff}',
    '.fo-gv-stage.is-zoomed .fo-gv-frame{overflow:visible;background:transparent}',
    '.fo-gv-frame img{width:100%!important;height:100%!important;padding:14px!important;object-fit:contain!important;display:block;transform-origin:50% 50%;transition:transform .25s ease-out;pointer-events:none}',
    '.fo-gv-arrow{position:absolute;top:50%;transform:translateY(-50%);width:52px;height:52px;border-radius:50%;background:#fff;border:1px solid #dde2ea;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(15,36,68,.10);cursor:pointer;padding:0;z-index:2}',
    '.fo-gv-arrow:hover{background:#f0f0f0}',
    '.fo-gv-arrow svg{width:22px;height:22px;stroke:' + NAVY + ';stroke-width:2.2;fill:none;stroke-linecap:round;stroke-linejoin:round}',
    '.fo-gv-prev{left:20px}.fo-gv-next{right:20px}',
    '.fo-gv-hint{display:flex;align-items:center;gap:8px;padding:0 4px;font-size:13px;font-weight:700;line-height:1.35;color:#5b6778;flex-shrink:0}',
    '.fo-gv-hint svg{width:16px;height:16px;flex-shrink:0;stroke:#5b6778;stroke-width:2;fill:none;stroke-linecap:round}',
    '.fo-gv .fo-gv-side{width:340px;flex-shrink:0;display:flex!important;flex-direction:column!important;gap:18px;min-height:0;height:100%}',
    '.fo-gv-top{display:flex;align-items:center;justify-content:space-between}',
    '.fo-gv-title{margin:0;font-family:var(--font-heading-family,"Lato",Arial,sans-serif);font-size:22px;font-weight:800;line-height:1.25;color:' + NAVY + '}',
    '.fo-gv-rule{width:36px;height:3px;background:' + GOLD + ';border-radius:2px;flex-shrink:0}',
    '.fo-gv .fo-gv-thumbs{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:10px;overflow-y:auto;min-height:0;padding:2px;align-content:start}',
    '.fo-gv .fo-gv-thumb{display:block!important;width:100%!important;height:auto!important;min-width:0!important;min-height:0!important;max-width:none!important;aspect-ratio:1/1!important;padding:4px!important;margin:0!important;border-radius:12px!important;background:#fff!important;border:1px solid #e3e7ed!important;cursor:pointer;box-shadow:none!important;line-height:0!important}',
    '.fo-gv .fo-gv-thumb:hover{border-color:' + NAVY + '!important}',
    '.fo-gv .fo-gv-thumb.is-on{border:2px solid ' + NAVY + '!important;padding:3px!important}',
    '.fo-gv .fo-gv-thumb img{width:100%!important;height:100%!important;object-fit:contain!important;border-radius:8px;display:block!important}',
    '.fo-gv .fo-gv-spacer{flex:1 1 auto!important;min-height:0}',
    '.fo-gv .fo-gv-thumb--video{position:relative!important;background:' + NAVY + '!important}',
    '.fo-gv .fo-gv-thumb--video img{object-fit:cover!important}',
    '.fo-gv-play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none}',
    '.fo-gv-play svg{width:34px;height:34px;filter:drop-shadow(0 2px 6px rgba(0,0,0,.25))}',
    '.fo-gv-vbox{display:none;border-radius:18px;overflow:hidden;background:#000}',
    '.fo-gv-vbox iframe{width:100%!important;height:100%!important;border:0;display:block}',
    '.fo-gv-stage.is-video{cursor:default}',
    '.fo-gv .fo-gv-d.is-video .fo-gv-zoom,.fo-gv .fo-gv-d.is-video .fo-gv-hint{display:none!important}',
    '.fo-gv .fo-gv-zoom{background:#e2e5ea;border-radius:14px;padding:14px;display:flex!important;flex-direction:column!important;gap:10px;flex-shrink:0;margin-top:auto!important}',
    '.fo-gv-zrow{display:flex;align-items:center;gap:10px}',
    '.fo-gv-zbtn{width:44px;height:44px;border-radius:10px;border:1px solid #dde2ea;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;color:' + NAVY + '}',
    '.fo-gv-zbtn:hover{background:#f0f0f0}',
    '.fo-gv-zbtn svg{width:18px;height:18px;stroke:' + NAVY + ';stroke-width:2.4;fill:none;stroke-linecap:round}',
    '.fo-gv-zpct{flex:1;text-align:center;font-size:18px;font-weight:800;color:' + NAVY + '}',
    '.fo-gv-reset{width:auto;padding:0 14px;font-size:14px;font-weight:700}',

    /* phone */
    '.fo-gv-m{display:flex;flex-direction:column;background:#f0f0f0}',
    '.fo-gv-mhead{display:flex;align-items:center;justify-content:space-between;padding:12px 12px 12px 18px;padding-top:calc(12px + env(safe-area-inset-top,0px));flex-shrink:0}',
    '.fo-gv-mhead .fo-gv-label{font-size:16px;letter-spacing:1.2px}',
    '.fo-gv-mbtns{display:flex;align-items:center;gap:10px}',
    '.fo-gv-m .fo-gv-mreset{display:none;height:40px;padding:0 16px;border-radius:999px;border:1.5px solid ' + NAVY + ';background:#fff;color:' + NAVY + ';font-size:14px;font-weight:800;cursor:pointer;align-items:center}',
    '.fo-gv-m.is-zoomed .fo-gv-mreset{display:flex}',
    '.fo-gv-mlist{flex:1;overflow:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;touch-action:pan-x pan-y}',
    '.fo-gv-mzoom{width:100%;padding-bottom:calc(24px + env(safe-area-inset-bottom,0px))}',
    '.fo-gv-mitem{position:relative;width:100%;background:#fff;overflow:hidden}',
    '.fo-gv-mitem img{width:100%!important;height:100%!important;padding:10px!important;object-fit:contain!important;display:block!important;pointer-events:none}',
    '.fo-gv-mhint{margin:12px 0 0;text-align:center;font-size:13px;color:#5b6778}'
  ].join('\n');

  function addCss() {
    if (document.getElementById('fo-gv-css')) return;
    var st = document.createElement('style');
    st.id = 'fo-gv-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ---------- helpers ---------- */
  var ICON = {
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg>',
    search: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
    muted: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9l5 6M22 9l-5 6"/></svg>',
    sound: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>',
    videoDot: '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="' + NAVY + '"/><path d="M8 6 L14.5 10 L8 14 Z" fill="#fff"/></svg>'
  };

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getData(secId) {
    var node = document.getElementById('fo-g-data-' + secId);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }
  function abs(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function usePhoneViewer() {
    return window.innerWidth <= 960 ||
      (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
  }

  var openViewer = null; /* the viewer currently on screen */
  var savedOverflow = '';
  function lockPage() {
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function unlockPage() {
    document.documentElement.style.overflow = savedOverflow || '';
    document.body.style.overflow = '';
  }
  function closeViewer() {
    if (!openViewer) return;
    if (openViewer.cleanup) openViewer.cleanup();
    if (openViewer.root && openViewer.root.parentNode) openViewer.root.parentNode.removeChild(openViewer.root);
    openViewer = null;
    unlockPage();
  }

  /* =====================================================================
     DESKTOP VIEWER
     ===================================================================== */
  function openDesktop(data, start, vids) {
    var imgs = data.images || [];
    vids = vids || [];
    if (!imgs.length) return;
    var total = imgs.length + vids.length;
    var idx = clamp(start || 0, 0, imgs.length - 1);
    function isVid(i) { return i >= imgs.length; }
    var z = 1, ox = 50, oy = 50;

    var root = el('div', 'fo-gv fo-gv-back');
    var panel = el('div', 'fo-gv-d');
    root.appendChild(panel);
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product photos');

    var stage = el('div', 'fo-gv-stage');
    var area = el('div', 'fo-gv-area');
    var frame = el('div', 'fo-gv-frame');
    var big = el('img');
    big.alt = '';
    big.draggable = false;
    frame.appendChild(big);
    area.appendChild(frame);
    var vbox = el('div', 'fo-gv-vbox');
    area.appendChild(vbox);
    stage.appendChild(area);

    var prev = el('button', 'fo-gv-arrow fo-gv-prev', ICON.prev);
    prev.type = 'button'; prev.setAttribute('aria-label', 'Previous photo');
    var next = el('button', 'fo-gv-arrow fo-gv-next', ICON.next);
    next.type = 'button'; next.setAttribute('aria-label', 'Next photo');
    if (total < 2) { prev.style.display = 'none'; next.style.display = 'none'; }
    stage.appendChild(prev);
    stage.appendChild(next);

    var hint = el('div', 'fo-gv-hint');

    var side = el('div', 'fo-gv-side');
    var top = el('div', 'fo-gv-top');
    top.appendChild(el('span', 'fo-gv-label', 'Product photos'));
    var x = el('button', 'fo-gv-x', ICON.x);
    x.type = 'button'; x.setAttribute('aria-label', 'Close photos');
    top.appendChild(x);
    side.appendChild(top);
    side.appendChild(el('h2', 'fo-gv-title', esc(data.title)));
    side.appendChild(el('div', 'fo-gv-rule'));

    var grid = el('div', 'fo-gv-thumbs');
    var thumbBtns = imgs.map(function (im, i) {
      var b = el('button', 'fo-gv-thumb', '<img src="' + esc(abs(im.thumb)) + '" alt="" loading="lazy">');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show photo ' + (i + 1));
      b.addEventListener('click', function () { show(i); });
      grid.appendChild(b);
      return b;
    });
    vids.forEach(function (v, k) {
      var poster = v.type === 'yt' ? '<img src="https://i.ytimg.com/vi/' + esc(v.id) + '/hqdefault.jpg" alt="" loading="lazy">' : '';
      var b = el('button', 'fo-gv-thumb fo-gv-thumb--video', poster + '<span class="fo-gv-play">' + ICON.videoDot + '</span>');
      b.type = 'button';
      b.setAttribute('aria-label', 'Play video' + (vids.length > 1 ? ' ' + (k + 1) : ''));
      b.addEventListener('click', function () { show(imgs.length + k); });
      grid.appendChild(b);
      thumbBtns.push(b);
    });
    side.appendChild(grid);
    side.appendChild(el('div', 'fo-gv-spacer'));

    var zbox = el('div', 'fo-gv-zoom');
    zbox.appendChild(el('span', 'fo-gv-label', 'Zoom'));
    var zrow = el('div', 'fo-gv-zrow');
    var zout = el('button', 'fo-gv-zbtn', ICON.minus); zout.type = 'button'; zout.setAttribute('aria-label', 'Zoom out');
    var zpct = el('span', 'fo-gv-zpct', '100%');
    var zin = el('button', 'fo-gv-zbtn', ICON.plus); zin.type = 'button'; zin.setAttribute('aria-label', 'Zoom in');
    var zreset = el('button', 'fo-gv-zbtn fo-gv-reset', 'Reset'); zreset.type = 'button';
    zrow.appendChild(zout); zrow.appendChild(zpct); zrow.appendChild(zin); zrow.appendChild(zreset);
    zbox.appendChild(zrow);
    side.appendChild(zbox);
    side.appendChild(hint);

    panel.appendChild(stage);
    panel.appendChild(side);
    root.addEventListener('click', function (e) { if (e.target === root) closeViewer(); });

    function fitFrame() {
      var r = imgs[idx].ratio || 1;
      var aw = area.clientWidth, ah = area.clientHeight;
      var w = ah * r, h = ah;
      if (w > aw) { w = aw; h = aw / r; }
      frame.style.width = Math.round(w) + 'px';
      frame.style.height = Math.round(h) + 'px';
    }
    function paint() {
      big.style.transform = 'scale(' + z + ')';
      big.style.transformOrigin = ox + '% ' + oy + '%';
      stage.classList.toggle('is-zoomed', z > 1);
      zpct.textContent = Math.round(z * 100) + '%';
      hint.innerHTML = ICON.search + (z > 1
        ? 'Move the mouse to look · Click to zoom out'
        : 'Click or scroll the photo to zoom');
    }
    function setZoom(nz, nx, ny) {
      z = clamp(Math.round(nz * 100) / 100, 1, 5);
      if (z === 1) { nx = 50; ny = 50; }
      if (nx != null) ox = nx;
      if (ny != null) oy = ny;
      paint();
    }
    /* photos switch instantly: show the copy the page already loaded,
       then swap in the sharp zoom copy as soon as it is ready */
    var ready = {};
    function sharp(i) { return abs(imgs[i].full || imgs[i].mid); }
    function quick(i) { return sharp(i).replace(/([?&]width=)\d+/, '$1900'); }
    function preload(i, cb) {
      var u = sharp(i);
      if (ready[u]) { if (cb) cb(); return; }
      var im = new Image();
      im.onload = function () { ready[u] = true; if (cb) cb(); };
      im.onerror = function () { if (cb) cb(); };
      im.src = u;
    }
    function fitVideo() {
      var aw = area.clientWidth, ah = area.clientHeight;
      var w = aw, h = aw * 9 / 16;
      if (h > ah) { h = ah; w = ah * 16 / 9; }
      vbox.style.width = Math.round(w) + 'px';
      vbox.style.height = Math.round(h) + 'px';
    }
    function show(i) {
      idx = (i + total) % total;
      thumbBtns.forEach(function (b, k) { b.classList.toggle('is-on', k === idx); });
      if (isVid(idx)) {
        var v = vids[idx - imgs.length];
        setZoom(1);
        frame.style.display = 'none';
        panel.classList.add('is-video');
        stage.classList.add('is-video');
        vbox.style.display = 'block';
        fitVideo();
        var src = v.type === 'yt'
          ? 'https://www.youtube.com/embed/' + v.id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1'
          : 'https://player.vimeo.com/video/' + v.id + '?autoplay=1';
        vbox.innerHTML = '<iframe src="' + esc(src) + '" title="Product video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
        return;
      }
      vbox.innerHTML = '';
      vbox.style.display = 'none';
      frame.style.display = '';
      panel.classList.remove('is-video');
      stage.classList.remove('is-video');
      var want = idx;
      var u = sharp(idx);
      big.src = ready[u] ? u : quick(idx);
      if (!ready[u]) preload(idx, function () { if (want === idx && ready[u]) big.src = u; });
      big.alt = imgs[idx].alt || '';
      fitFrame();
      setZoom(1);
    }
    function point(e) {
      var r = frame.getBoundingClientRect();
      return {
        x: clamp(((e.clientX - r.left) / r.width) * 100, 0, 100),
        y: clamp(((e.clientY - r.top) / r.height) * 100, 0, 100)
      };
    }

    function onArrow(e) { return e.target.closest && e.target.closest('.fo-gv-arrow'); }
    stage.addEventListener('click', function (e) {
      if (onArrow(e) || isVid(idx)) return;
      if (z > 1) { setZoom(1); return; }
      var p = point(e);
      setZoom(2.5, p.x, p.y);
    });
    stage.addEventListener('mousemove', function (e) {
      if (z <= 1 || onArrow(e) || isVid(idx)) return;
      var p = point(e);
      ox = p.x; oy = p.y;
      big.style.transformOrigin = ox + '% ' + oy + '%';
    });
    function onWheel(e) {
      if (isVid(idx)) return;
      e.preventDefault();
      var p = point(e);
      setZoom(z + (e.deltaY < 0 ? 0.35 : -0.35), p.x, p.y);
    }
    stage.addEventListener('wheel', onWheel, { passive: false });
    prev.addEventListener('click', function () { show(idx - 1); });
    next.addEventListener('click', function () { show(idx + 1); });
    zin.addEventListener('click', function () { setZoom(z + 0.5); });
    zout.addEventListener('click', function () { setZoom(z - 0.5); });
    zreset.addEventListener('click', function () { setZoom(1); });
    x.addEventListener('click', closeViewer);

    function onKey(e) {
      if (e.key === 'Escape') closeViewer();
      else if (e.key === 'ArrowLeft' && total > 1) show(idx - 1);
      else if (e.key === 'ArrowRight' && total > 1) show(idx + 1);
    }
    function onResize() { if (isVid(idx)) fitVideo(); else fitFrame(); }
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);

    closeViewer();
    lockPage();
    document.body.appendChild(root);
    openViewer = {
      root: root,
      cleanup: function () {
        vbox.innerHTML = '';
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
      }
    };
    show(idx);
    x.focus({ preventScroll: true });
    /* load the sharp copies of the other photos in the background, one by one */
    (function warm(k) {
      if (k >= imgs.length || !openViewer || openViewer.root !== root) return;
      preload((idx + k) % imgs.length, function () { warm(k + 1); });
    })(1);
  }

  /* =====================================================================
     PHONE VIEWER — full screen, photos one under the other, pinch zoom
     ===================================================================== */
  function openPhone(data, start) {
    var imgs = data.images || [];
    if (!imgs.length) return;
    start = clamp(start || 0, 0, imgs.length - 1);

    var root = el('div', 'fo-gv fo-gv-m');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product photos');

    var head = el('div', 'fo-gv-mhead');
    head.appendChild(el('span', 'fo-gv-label', 'Product photos'));
    var btns = el('div', 'fo-gv-mbtns');
    var reset = el('button', 'fo-gv-mreset', 'Reset zoom');
    reset.type = 'button';
    var x = el('button', 'fo-gv-x', ICON.x);
    x.type = 'button'; x.setAttribute('aria-label', 'Close photos');
    btns.appendChild(reset);
    btns.appendChild(x);
    head.appendChild(btns);

    var list = el('div', 'fo-gv-mlist');
    var layer = el('div', 'fo-gv-mzoom');
    list.appendChild(layer);
    var items = imgs.map(function (im, i) {
      var item = el('div', 'fo-gv-mitem');
      item.style.aspectRatio = String(im.ratio || 1);
      var img = el('img');
      img.alt = im.alt || '';
      img.draggable = false;
      img.loading = Math.abs(i - start) <= 1 ? 'eager' : 'lazy';
      img.src = abs(im.mid || im.full);
      item.appendChild(img);
      layer.appendChild(item);
      return item;
    });
    layer.appendChild(el('p', 'fo-gv-mhint', 'Use two fingers to zoom in'));
    var zoomer = pinchAll(list, layer, function (z) { root.classList.toggle('is-zoomed', z > 1); });
    reset.addEventListener('click', function () { zoomer.reset(); });

    root.appendChild(head);
    root.appendChild(list);
    x.addEventListener('click', closeViewer);

    function onKey(e) { if (e.key === 'Escape') closeViewer(); }
    document.addEventListener('keydown', onKey);

    closeViewer();
    lockPage();
    document.body.appendChild(root);
    openViewer = { root: root, cleanup: function () { document.removeEventListener('keydown', onKey); } };
    list.scrollTop = items[start].offsetTop;
  }

  /* two-finger zoom on the WHOLE gallery (like Amazon): every photo grows
     together, the photos stay whole, and one finger scrolls in any direction */
  function pinchAll(list, layer, onChange) {
    var z = 1, g = null;
    function setW(nz) { z = nz; layer.style.width = (z * 100) + '%'; if (onChange) onChange(z); }
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    list.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      var r = list.getBoundingClientRect();
      var cx = (e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left;
      var cy = (e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top;
      g = { d0: dist(e.touches), z0: z, cx: cx, cy: cy,
            fx: (list.scrollLeft + cx) / z, fy: (list.scrollTop + cy) / z };
    }, { passive: true });
    list.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2 || !g) return;
      e.preventDefault();
      setW(clamp(g.z0 * (dist(e.touches) / g.d0), 1, 4));
      list.scrollLeft = g.fx * z - g.cx;
      list.scrollTop = g.fy * z - g.cy;
    }, { passive: false });
    list.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) g = null;
      if (e.touches.length === 0 && z < 1.08) setW(1);
    }, { passive: true });
    return {
      reset: function () {
        var cy = list.clientHeight / 2;
        var fy = (list.scrollTop + cy) / z;
        setW(1);
        list.scrollLeft = 0;
        list.scrollTop = Math.max(0, fy - cy);
      }
    };
  }

  /* =====================================================================
     SWIPE GALLERY on the product page (phone/tablet)
     ===================================================================== */
  function videoInfo(url) {
    if (!url) return null;
    var m = url.match(/(?:youtube\.com\/(?:embed\/|watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (m) return { type: 'yt', id: m[1] };
    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return { type: 'vimeo', id: m[1] };
    return null;
  }
  function videoSrc(v) {
    if (v.type === 'yt') {
      return 'https://www.youtube.com/embed/' + v.id + '?autoplay=1&mute=1&playsinline=1&loop=1&playlist=' + v.id +
        '&controls=0&rel=0&modestbranding=1&enablejsapi=1&origin=' + encodeURIComponent(location.origin);
    }
    return 'https://player.vimeo.com/video/' + v.id + '?autoplay=1&muted=1&loop=1&playsinline=1&controls=0&title=0&byline=0&portrait=0';
  }
  function tell(frame, v, what) {
    if (!frame || !frame.contentWindow) return;
    var msgs = [];
    if (v.type === 'yt') {
      var yt = { play: ['playVideo'], pause: ['pauseVideo'], mute: ['mute'], unmute: ['unMute', 'setVolume'] }[what] || [];
      yt.forEach(function (f) {
        msgs.push(JSON.stringify({ event: 'command', func: f, args: f === 'setVolume' ? [100] : [] }));
      });
    } else {
      if (what === 'play') msgs.push({ method: 'play' });
      if (what === 'pause') msgs.push({ method: 'pause' });
      if (what === 'mute') { msgs.push({ method: 'setMuted', value: true }); msgs.push({ method: 'setVolume', value: 0 }); }
      if (what === 'unmute') { msgs.push({ method: 'setMuted', value: false }); msgs.push({ method: 'setVolume', value: 1 }); }
    }
    msgs.forEach(function (m) { try { frame.contentWindow.postMessage(m, '*'); } catch (e) {} });
  }

  function findVideos(secId) {
    var section = document.getElementById('fo-section-' + secId) || document;
    var raw = section.querySelector('#fo-raw-description');
    var list = [];
    if (raw) {
      raw.querySelectorAll('iframe').forEach(function (f) {
        var v = videoInfo(f.getAttribute('src') || f.getAttribute('data-src') || '');
        if (v && !list.some(function (o) { return o.id === v.id; })) list.push({ type: v.type, id: v.id });
      });
    }
    return list;
  }

  function initSwipe(wrap) {
    if (!wrap || wrap.getAttribute('data-fo-g-ready')) return;
    wrap.setAttribute('data-fo-g-ready', '1');
    var secId = wrap.getAttribute('data-fo-gallery');
    var track = wrap.querySelector('[data-fo-g-track]');
    var dotsBox = wrap.querySelector('[data-fo-g-dots]');
    if (!track || !dotsBox) return;

    /* video slides — same YouTube / Vimeo links the desktop video thumbnails use */
    var vids = findVideos(secId);
    vids.forEach(function (v) {
      var slide = el('div', 'fo-g-slide');
      var box = el('div', 'fo-g-video');
      if (v.type === 'yt') {
        var poster = el('img');
        poster.src = 'https://i.ytimg.com/vi/' + v.id + '/hqdefault.jpg';
        poster.alt = 'Product video';
        poster.loading = 'lazy';
        box.appendChild(poster);
      }
      box.appendChild(el('div', 'fo-g-video-cover'));
      var snd = el('button', 'fo-g-sound', ICON.muted);
      snd.type = 'button';
      snd.setAttribute('aria-label', 'Turn sound on');
      box.appendChild(snd);
      slide.appendChild(box);
      track.appendChild(slide);
      v.box = box; v.btn = snd; v.muted = true; v.frame = null;
      snd.addEventListener('click', function (e) {
        e.stopPropagation();
        v.muted = !v.muted;
        tell(v.frame, v, v.muted ? 'mute' : 'unmute');
        snd.innerHTML = v.muted ? ICON.muted : ICON.sound;
        snd.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
      });
    });

    var slides = Array.prototype.slice.call(track.children);
    var nImg = slides.length - vids.length;

    /* dots */
    var dots = slides.map(function (s, i) {
      var isVid = i >= nImg;
      var d = el('button', 'fo-g-dot' + (isVid ? ' fo-g-dot--video' : ''), isVid ? ICON.videoDot : '<span></span>');
      d.type = 'button';
      d.setAttribute('aria-label', isVid ? 'Go to video' : 'Go to photo ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      dotsBox.appendChild(d);
      return d;
    });
    if (slides.length < 2) dotsBox.style.display = 'none';

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return track.clientWidth + gap;
    }
    function go(i) { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }

    var cur = -1;
    function activate(i) {
      if (i === cur) return;
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      vids.forEach(function (v, k) {
        var on = (nImg + k) === i;
        if (on) {
          if (!v.frame) {
            var f = el('iframe');
            f.src = videoSrc(v);
            f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
            f.setAttribute('title', 'Product video');
            f.addEventListener('load', function () {
              if (v.type === 'yt') { try { f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1 }), '*'); } catch (e) {} }
              if (!v.muted) tell(f, v, 'unmute');
            });
            v.box.insertBefore(f, v.box.querySelector('.fo-g-video-cover'));
            v.frame = f;
          } else {
            tell(v.frame, v, 'play');
          }
        } else if (v.frame) {
          tell(v.frame, v, 'pause');
        }
      });
    }
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        activate(clamp(Math.round(track.scrollLeft / step()), 0, slides.length - 1));
      });
    }, { passive: true });
    activate(0);

    /* tap a photo -> open the viewer on that photo */
    track.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fo-g-open]');
      if (!b) return;
      FOGallery.open(secId, parseInt(b.getAttribute('data-fo-g-open'), 10) || 0);
    });
  }

  function initAll(scope) {
    addCss();
    (scope || document).querySelectorAll('[data-fo-gallery]').forEach(initSwipe);
  }

  var FOGallery = {
    open: function (secId, idx) {
      var data = getData(secId);
      if (!data || !data.images || !data.images.length) return;
      addCss();
      if (usePhoneViewer()) openPhone(data, idx);
      else openDesktop(data, idx, findVideos(secId));
    },
    close: closeViewer,
    init: initAll
  };
  window.FOGallery = FOGallery;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  /* theme editor: re-init when the section reloads */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();